module.exports = __webpack_public_path__ + "img/Body C.5285e915.png";